var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters.isAuth)?_c('div',{staticClass:"wrapper sidebar-mini"},[_c('main-header'),_c('side-bar'),_c('div',{staticClass:"content-wrapper px-2 py-4"},[_c('router-view')],1)],1):_c('div',{staticClass:"container"},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }